import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import { ThaiDatePicker } from "thaidatepicker-react";

const MyThaiDatePick = (props) => {

  const {
    disabled = false,
    setProbsDate = null,
    setDateObj = null,
    maxDate = null,
    minDate = null,
    placeholderText = "",
    defaultValue = null,
    invalidProps = false,
    requireProps = false,
    showDateFormat = "DD / MM / YYYY",
    rounded = "rounded-2",
    showClearButton = false
  } = props;

  dayjs.locale("th")

  const [selectedDate, setSelectedDate] = useState();

  useEffect(() => {
    if (defaultValue !== null) {
      setSelectedDate(defaultValue)
    }
  }, [])
  
  
  const handleDatePickerChange = (e) => {
    setSelectedDate(e);

    setDateObj !== null ? 
        setDateObj(e) :
        setProbsDate(e)
      
  };

  const headerButtonClassName = "btn btn-light border border-dark-subtle rounded-2 py-0"
  
  return (
    <div>
        <ThaiDatePicker
            value={selectedDate}
            disabled={disabled}
            header={{
                prevButtonClassName: headerButtonClassName,
                nextButtonClassName: headerButtonClassName
            }}
            minDate = {minDate || undefined}
            maxDate = {maxDate || undefined}
            placeholder={placeholderText}
            onChange={(christDate) => handleDatePickerChange(christDate)}
            customInput={Input}
            inputProps={{
              displayFormat: showDateFormat,
              className: `btn-light border ${invalidProps ? "border-danger" : "border-secondary-subtle"} ${rounded}`,
              readOnly: true,
              invalid: invalidProps,
              require: requireProps,
            }}
            clearable = {showClearButton}
        />
    </div>
    );
  };

export default MyThaiDatePick